var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flexbox wrap grey lighten-4 align-center"},[_vm._l((_vm.breadcrumb),function(crumb,idx){return [_c('n-button',{attrs:{"to":crumb.url,"flat":"","small":"","exact-active-class":"info--text"}},[_vm._v(_vm._s(crumb.title))]),(idx < _vm.breadcrumb.length - 1)?_c('span',{},[_vm._v(">")]):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }